import React, { Component } from 'react';
import { connect } from 'react-redux';
import './UploadQuestionPhoto.scss';
import { Storage } from '../../../shared/services/aws';
import LoadingButton from '../../../shared/ui/LoadingButton';
import uuidv4 from 'uuid/v4';

class UploadQuestionPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isLoading: false,
        questionPhotoUrl: this.props.questionPhoto ? this.getS3Link(this.props.questionPhoto) : null,
        questionPhotoKey: null,
     };
  }

  inputFile;

  // ----------------------
  // Methods
  // ----------------------

  getS3Link(imageUrl) {
    Storage.get(imageUrl)
      .then(result => {
        this.setState({
          questionPhotoUrl: result
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  triggerUpload() {
    this.inputFile.click();
  }

  uploadFile(event) {
    const file = event.target.files[0];
    let fileExtension = file.type.split('/')[1];
    let fileName = uuidv4() + '.' + fileExtension;
    const s3Key = `${this.props.userContext.departmentGuid}/tests/${this.props.testTemplateId}/${fileName}`;

    this.setState({
      isLoading: true
    });

    Storage.put(s3Key, file, {contentType: file.type})
      .then((result) => {
        this.setState({
          isLoading: false,
          questionPhotoKey: result.key
        });

        this.getS3Link(result.key);
        this.updatePhoto();
      })
      .catch((error) => {
        this.setState({
            isLoading: false
        });
        console.log(`[AttachmentForm] uploadFile() error: ${JSON.stringify(error)}`);
      });
  }

  updatePhoto() {
    this.props.onUpdatePhoto({
      questionPhotoUrl: this.state.questionPhotoKey
    });
  }

  render() {
    return (
      <div className="upload-question-photo">
        <input type="file" ref={(ref) => this.inputFile = ref} onChange={e => this.uploadFile(e)}/>
        
        {this.props.question &&
          <label className="photo-label">
            Photo
          </label>
        }

        <div className="img-container">
            {this.state.questionPhotoUrl &&
              <img className="image" src={this.state.questionPhotoUrl} />
            }
        </div>

        <div className="upload-btn">
            <LoadingButton
              primary
              icon="fa fa-upload"
              text="Upload Photo"
              type="button"
              isLoading={this.state.isLoading}
              onClick={() => this.triggerUpload()}
            />
        </div>
      </div>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps)(UploadQuestionPhoto);
